// error
export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';

// auth
export const SET_USER = 'SET_USER';
export const LOG_OUT = 'LOG_OUT';

// reports
export const SET_REPORTS = 'SET_REPORTS';